/* eslint-disable no-undef */
import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Login Redux States
import { GET_GROUP } from "./actionTypes"
import { apiError, getGroupSuccess } from "./actions"

//Include Both Helper File with needed methods
import { getGroup, getGroupNewApi } from "../../../helpers/backend_helper"

function* get(params) {
  try {
    const response = yield call(getGroupNewApi, params.payload.id)
    yield put(getGroupSuccess(response))
  } catch (error) {
    yield put(apiError(error))
  }
}

function* groupGetSaga() {
  yield takeEvery(GET_GROUP, get)
}

export default groupGetSaga
